import { render, staticRenderFns } from "./DataPermissions.vue?vue&type=template&id=48d0425a&scoped=true"
import script from "./DataPermissions.vue?vue&type=script&lang=js"
export * from "./DataPermissions.vue?vue&type=script&lang=js"
import style0 from "./DataPermissions.vue?vue&type=style&index=0&id=48d0425a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d0425a",
  null
  
)

export default component.exports